
export default {
  name: "BaseFooter",
};
